import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/page-not-found.svg';

const _withScopeId = n => (_pushScopeId("data-v-952950d2"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "container"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "container__img",
  src: _imports_0,
  alt: "Ilustracja przedstawiająca błąd 404"
}, null, -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "container__description"
}, "Ups, wygląda na to że wyszukana strona nie istnieje!", -1));

const _hoisted_4 = /*#__PURE__*/_createTextVNode("Wróć do poprzedniej strony");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _hoisted_3, _createVNode(_component_el_button, {
    class: "container__button",
    color: "#e46f4a",
    type: "primary",
    onClick: $setup.handleReturnButton
  }, {
    default: _withCtx(() => [_hoisted_4]),
    _: 1
  }, 8, ["onClick"])]);
}